import { Moment } from 'moment';

import { Nullable } from './common';

export enum DateRange {
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  THIS_WEEK = 'THIS_WEEK',
  LAST_WEEK = 'LAST_WEEK',
  THIS_MONTH = 'THIS_MONTH',
  LAST_MONTH = 'LAST_MONTH',
}

export type DatesPartialParam = {
  dates?: [Nullable<Moment>, Nullable<Moment>];
};
